import { makeStyles } from '@mui/styles';

// we use this class to find node in the cell
const useStyles = makeStyles(() => ({ cellContent: {} }));

export function useCellContentClass() {
  return useStyles().cellContent;
}
